import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";
import Homepage from './screens/Homepage';
import ImageFromTextImage from './screens/ImageFromTextImage';
import ClipAudioProjectsScreen from './screens/ClipAudio/ClipAudioProjectsScreen';
import ClipAudioPipelineScreen from './screens/ClipAudio/ClipAudioPipelineScreen';
import ClipAudioDetailsScreen from './screens/ClipAudio/ClipAudioDetailsScreen';
import SeanceProjectsScreen from './screens/Seance/SeanceProjectsScreen';
import SeanceDetailsScreen from './screens/Seance/SeanceDetailsScreen';
import SeanceCreationScreen from './screens/Seance/SeanceCreationScreen';
import SeancePresentation from './screens/Seance/SeancePresentation';
import ParachaScreen from './screens/ParachaScreen';
import SessionEditor from './pages/SessionEditor';
import MusicsScreen from './screens/MusicsScreen';
import ImagesGaleryScreen from './screens/ImagesGaleryScreen';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  if (loading) {
    return <div>Chargement...</div>;
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return children;
};

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  if (loading) {
    return <div>Chargement...</div>;
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route 
          path="/image" 
          element={
            <ProtectedRoute>
              <ImageFromTextImage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/audio" 
          element={
            <ProtectedRoute>
              <ClipAudioProjectsScreen />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/audio/:id" 
          element={
            <ProtectedRoute>
              <ClipAudioDetailsScreen />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/audio/pipeline/:id" 
          element={
            <ProtectedRoute>
              <ClipAudioPipelineScreen />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/session/:sessionId" 
          element={
            <ProtectedRoute>
              <SessionEditor />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/seance" 
          element={
            <ProtectedRoute>
              <SeanceProjectsScreen />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/seance/create" 
          element={
            <ProtectedRoute>
              <SeanceCreationScreen />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/seance/presentation/:seanceId" 
          element={<SeancePresentation />}
        />
        <Route 
          path="/seance/:seanceId" 
          element={
            <ProtectedRoute>
              <SeanceDetailsScreen />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/paracha" 
          element={
            <ProtectedRoute>
              <ParachaScreen />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/musics" 
          element={
            <ProtectedRoute>
              <MusicsScreen />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/images-gallery" 
          element={
            <ProtectedRoute>
              <ImagesGaleryScreen />
            </ProtectedRoute>
          } 
        />
      </Routes>
    </Router>
  );
}

export default App;
